import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-dialog-footer',
  templateUrl: './dialog-footer.component.html',
  styleUrls: ['./dialog-footer.component.scss']
})
export class DialogFooterComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
